import { Role } from "@Constants/types";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { Path } from "typescript";
import { getRole, getRoleSafe } from "@Security/stateHelpers";
import { IsWhiteLabel } from "@Constants/tokens";

type SecuredRouteProps = {
  children: JSX.Element;
  exact?: boolean;
  path?: Path | readonly Path[];
  roles?: Array<Role>;
  nonWhiteLabel?: boolean;
};

export function SecuredRoute({
  children,
  exact,
  path,
  roles,
  nonWhiteLabel,
}: SecuredRouteProps): JSX.Element {
  const isAuth = useSelector((state) => (state as any).auth) as boolean;
  const userRole = getRoleSafe();
  
  return (
    <Route exact={exact} path={path}>
      {isAuth &&
      (roles === undefined || (userRole && roles.includes(userRole))) &&
      (nonWhiteLabel === undefined ||
        !IsWhiteLabel() ||
        (IsWhiteLabel() && !nonWhiteLabel)) ? (
        children
      ) : (
        <Redirect to="/" />
      )}
    </Route>
  );
}
